export default __webpack_public_path__ + "static/stacked-rocks-3f8bb5489b71d859322041bc4cd6505b.png";